var render, staticRenderFns
import script from "./ib-drawer.vue?vue&type=script&lang=js&"
export * from "./ib-drawer.vue?vue&type=script&lang=js&"
import style0 from "./ib-drawer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16baec6a')) {
      api.createRecord('16baec6a', component.options)
    } else {
      api.reload('16baec6a', component.options)
    }
    
  }
}
component.options.__file = "src/components/view/ib-drawer.vue"
export default component.exports